import * as React from 'react';

const CreateClassicGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path fill="#FEFEFE" d="M28.833 110.789h86.334v-83.25H28.833z" />
            <path
                d="M29.604 110.018h84.792V28.31H29.604v81.708zm-1.541 1.542h87.874V26.768H28.064v84.792z"
                fill="#6A6B6E"
            />
            <path fill="#F26932" d="M38.083 72.247h67.834V49.122H38.083z" />
            <path
                d="M38.854 71.476h66.292V49.893H38.854v21.583zm-1.541 1.542h69.374V48.351H37.314v24.667z"
                fill="#6A6B6E"
            />
            <path
                d="M30.375 109.247h83.25V29.08h-83.25v80.167zm-3.083 3.083h89.416V25.997H27.292v86.333z"
                fill="#363A43"
            />
            <path
                fill="#363A43"
                d="M28.833 41.414h86.334V38.33H28.833zM33.458 35.247h3.084v-3.083h-3.084zM39.625 35.247h3.083v-3.083h-3.083zM45.792 35.247h3.083v-3.083h-3.083z"
            />
            <path
                fill="#363A43"
                d="M51.958 39.872h3.084V27.54h-3.084zM58.125 35.247h52.417v-3.083H58.125zM39.625 70.705h64.75V50.664h-64.75v20.041zm-3.083 3.084h70.916V47.58H36.542V73.79zM38.083 93.83h41.625v-3.083H38.083zM82.792 93.83h24.666v-3.083H82.792zM38.083 99.997h60.125v-3.083H38.083zM38.083 87.579h60.125v-3.083H38.083z"
            />
            <path
                d="M80.738 66.338H63.262l7.827-8.53 4.266 4.648.91-.993 4.473 4.875zm-2.604-7.334a2.5 2.5 0 11-.001-5 2.5 2.5 0 01.001 5z"
                fill="#FEFEFE"
            />
            <path d="M0 0h144v144H0z" />
        </g>
    </svg>
);

CreateClassicGraphicSvg.displayName = 'CreateClassicGraphicSvg';
export default CreateClassicGraphicSvg;
